module.exports = __webpack_public_path__ + "img/google-logo.78402d35.png";